import React, { useCallback } from 'react';
import { useForm } from 'react-final-form';

import { SELECT_ALL_SUFFIX } from '../../../constants';

export const useHandleSelectAllChange = ({ selectAllFieldRef, mainSelectAllFieldRef, refsList, prefFieldId }: {
    mainSelectAllFieldRef?: React.RefObject<HTMLInputElement>;
    prefFieldId?: string;
    refsList?: React.RefObject<HTMLInputElement>[];
    selectAllFieldRef: React.RefObject<HTMLInputElement>;
}) => {
    const formAPI = useForm();

    return useCallback((event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (!selectAllFieldRef.current) {
            return;
        }

        const fieldName = event.currentTarget.name;
        const childFields = formAPI.getRegisteredFields()
            .filter(item => item.includes(fieldName.split(SELECT_ALL_SUFFIX)[0]) && !item.includes(fieldName));
        const checkedChildFieldsCount = childFields.filter(item => formAPI.getState().values[item]).length;
        const areAllChildrenChecked = checkedChildFieldsCount === childFields.length;

        formAPI.batch(() => {
            childFields.forEach(name => {
                formAPI.change(name, !areAllChildrenChecked);
            });
            formAPI.change(fieldName, !areAllChildrenChecked);
        });

        // set appropriate attribute to all channels checkboxes in case when top level "Select All" field was clicked
        Array.isArray(refsList) && refsList.forEach(ref => {
            if (ref.current) {
                ref.current.indeterminate = false;
            }
        });

        // set appropriate value to top level "Select All" field in case if channel with available products was clicked
        if (mainSelectAllFieldRef && mainSelectAllFieldRef.current && prefFieldId) {
            const selectAllField = `${prefFieldId}${SELECT_ALL_SUFFIX}`;
            const preferencesFields = formAPI.getRegisteredFields()
                .filter(item => item.includes(prefFieldId) && !item.includes(selectAllField));
            const formValues = formAPI.getState().values;
            const itemFlag = areAllChildrenChecked
                ? preferencesFields.some(item => formValues[item])
                : preferencesFields.every(item => formValues[item]);

            mainSelectAllFieldRef.current.indeterminate = areAllChildrenChecked ? itemFlag : !itemFlag;
            formAPI.change(selectAllField, itemFlag);
        }

        selectAllFieldRef.current.indeterminate = false;
    }, [formAPI, refsList, prefFieldId, selectAllFieldRef, mainSelectAllFieldRef]);
};
